import * as React from 'react';
import styled from 'styled-components';
import { defaultStyle, invertedStyle } from './styling';

export const StyledLink = styled.a<{
  variant: 'default' | 'inverted';
  margin?: string;
}>`
  cursor: pointer;
  ${(props) => (props.variant === 'inverted' ? invertedStyle : defaultStyle)}
  ${(props) => (props.margin ? `margin: ${props.margin};` : '')}
`;

export interface HyperlinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  id?: string;
  variant: 'default' | 'inverted';
  href: string;
  disabled?: boolean;
  margin?: string;
  children?: any;
  className?: string;
}

const HyperLink: React.FunctionComponent<HyperlinkProps> = ({ children, target = '_blank', variant = 'default', ...props }: HyperlinkProps) => {
  return (
    <StyledLink {...props} variant={variant} target={target} rel="noopener noreferrer">
      {children}
    </StyledLink>
  );
};

export default HyperLink;
